export default __webpack_public_path__ + "static/media/fund-progress-logo.06b37804.png";